export default __webpack_public_path__ + "static/media/buyok.6be0ae5f.gif";